// extracted by mini-css-extract-plugin
export default {"container":"UOVxPb","title":"enYFAm","textButton":"yEi2iI"};